import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import Dialog from 'components/dialog';
import { primitive } from 'styles/constants/primitives';

import { ChangeStoreConfirmationDialogProps } from './types';

export const ChangeStoreConfirmationDialog = ({
  onDismiss,
  onConfirm,
  showDialog,
}: ChangeStoreConfirmationDialogProps) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      showDialog={showDialog}
      headingComponent={
        <View style={styles.dialogHeaderContainer}>
          <Icon variant="errorFill" size="$11" />
          <Text style={styles.dialogHeaderText}>
            {formatMessage({ id: 'changeRestaurantDialogHeading' })}
          </Text>
        </View>
      }
      bodyComponent={
        <Text style={styles.dialogBodyText}>
          {formatMessage({ id: 'changeRestaurantDialogBody' })}
        </Text>
      }
      confirmButtonLabel={formatMessage({ id: 'changeRestaurantDialogConfirmButtonLabel' })}
      confirmDialog={onConfirm}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Change Store Confirmation from Checkout"
      isErrorModal
      showCloseButton
    />
  );
};

const styles = StyleSheet.create({
  dialogHeaderText: {
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 16,
    marginTop: 8,
    textAlign: 'center',
    color: primitive.bk.$bbqBrown,
  },
  dialogHeaderContainer: {
    alignItems: 'center',
  },
  dialogBodyText: {
    fontFamily: primitive.fontFamily.$body,
    textAlign: 'center',
    marginVertical: 12,
    color: primitive.bk.$bbqBrown,
  },
});
